// src/components/common/LoadingScreen.js
import React from 'react';
import { Sparkles, Utensils } from 'lucide-react';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 flex flex-col items-center justify-center relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-r from-amber-200 to-yellow-300 rounded-full blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute top-1/2 right-1/4 w-60 h-60 bg-gradient-to-r from-red-200 to-pink-300 rounded-full blur-3xl opacity-30 animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-gradient-to-r from-orange-200 to-amber-300 rounded-full blur-3xl opacity-20 animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 text-center">
        {/* Spinning meat icon */}
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full blur-xl opacity-60"></div>
          <div className="relative w-32 h-32 bg-gradient-to-br from-amber-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-2xl animate-spin-slow">
            <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center">
              <Utensils className="w-12 h-12 text-white" />
            </div>
          </div>
          <Sparkles className="absolute -top-2 -right-2 w-8 h-8 text-yellow-400 animate-pulse" />
          <Sparkles className="absolute -bottom-2 -left-2 w-8 h-8 text-amber-400 animate-pulse delay-300" />
        </div>

        {/* Glowing text */}
        <h2 className="text-5xl font-bold mb-6 bg-gradient-to-r from-gray-900 via-amber-700 to-orange-600 bg-clip-text text-transparent animate-pulse">
          Sir Henry Butchery
        </h2>
        
        {/* Loading dots animation */}
        <div className="flex justify-center items-center space-x-4">
          <div className="w-3 h-3 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-gradient-to-r from-orange-400 to-red-500 rounded-full animate-bounce delay-100"></div>
          <div className="w-3 h-3 bg-gradient-to-r from-red-400 to-pink-500 rounded-full animate-bounce delay-200"></div>
        </div>

        {/* Loading message with typing animation */}
        <div className="mt-8 relative">
          <p className="text-gray-600 text-lg font-semibold animate-pulse">
            Preparing Premium Quality Meats
          </p>
          <div className="mt-2 h-1 w-48 mx-auto bg-gradient-to-r from-transparent via-amber-500 to-transparent rounded-full animate-glow"></div>
        </div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 4}s`
            }}
          />
        ))}
      </div>
    </div>
  );
}

// Add custom animations to your tailwind.config.js
// module.exports = {
//   theme: {
//     extend: {
//       animation: {
//         'spin-slow': 'spin 3s linear infinite',
//         'float': 'float 6s ease-in-out infinite',
//         'glow': 'glow 2s ease-in-out infinite',
//       },
//       keyframes: {
//         float: {
//           '0%, 100%': { transform: 'translateY(0px)' },
//           '50%': { transform: 'translateY(-20px)' },
//         },
//         glow: {
//           '0%, 100%': { opacity: 0.5 },
//           '50%': { opacity: 1 },
//         },
//       },
//     },
//   },
// }

export default LoadingScreen;